
import { Route, Redirect } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import Pending from "./Pending";

export default function PrivateRoute({ component: Component, initialTab, setInitialTab, ...rest }) {
  const { currentUser, retailerId } = useAuth()

  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <Route
      {...rest}
      render={props => {
        return currentUser ? 
          (retailerId ? 
            <>{getLayout(<Component initialTab={initialTab} setInitialTab={setInitialTab} {...props} />)}</> :
            <>{getLayout(<Pending />)}</>
          ) :
          <Redirect to="/login" />
      }}
    ></Route>

    // <Route
    //   {...rest}
    //   render={props => {
    //     return currentUser ? 
    //       <>{getLayout(<Component initialTab={initialTab} setInitialTab={setInitialTab} {...props} />)}</>
    //       : <Redirect to="/login" />
    //   }}
    // ></Route>
  )
}